"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _theme = _interopRequireDefault(require("./styles/theme"));
var _lodash = require("lodash");
var _Icon = _interopRequireDefault(require("./Icon"));
var _excluded = ["testID", "label", "onBlur", "onFocus", "type", "refs", "fixedLabel", "onChange", "uppercase"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};
var FloatingLabelInput = _styledComponents["default"].article.withConfig({
  displayName: "FloatingLabelInput",
  componentId: "sc-vv7mya-0"
})(["width:100%;max-width:320px;"]);
var FloatingLabelInputContainer = _styledComponents["default"].div.withConfig({
  displayName: "FloatingLabelInputContainer",
  componentId: "sc-vv7mya-1"
})(["display:flex;flex-direction:column;justify-content:flex-end;position:relative;height:2em;border-bottom:1px solid ", ";font-size:inherit;padding-bottom:2px;", " border-color:", ";transition:border-color 0.2s ease-out;"], _theme["default"].lightGrey, function (props) {
  return props.fixedLabel && (0, _styledComponents.css)(["display:grid;grid-template-columns:max-content 1fr;justify-content:start;align-content:end;"]);
}, function (props) {
  return props.hasFocus ? _theme["default"].info : _theme["default"].lightGrey;
});
var FloatingLabel = _styledComponents["default"].label.withConfig({
  displayName: "FloatingLabel",
  componentId: "sc-vv7mya-2"
})(["padding:0;margin:0;border:0;position:absolute;color:", ";bottom:0;transition:transform 0.2s ease-out,color 0.2s ease-out;transform-origin:left top;transform:", ";cursor:text;pointer-events:none;font-family:Raleway;font-style:normal;font-weight:normal;font-size:16px;text-transform:", ";", ""], function (props) {
  return props.active ? _theme["default"].darkPrimaryActive : _theme["default"].lightGrey;
}, function (props) {
  return props.active ? 'translate3d(0, -80%, 0) scale(0.90)' : 'none';
}, function (props) {
  return props.uppercase ? 'uppercase' : 'none';
}, function (props) {
  return props.fixedLabel && (0, _styledComponents.css)(["position:relative;transform:none;padding-right :4px;"]);
});
var FloatingInput = _styledComponents["default"].input.withConfig({
  displayName: "FloatingInput",
  componentId: "sc-vv7mya-3"
})(["padding:0;margin:0;border:none;outline:none;font-size:1em;&::placeholder{color:", ";transition:opacity 0.2s cubic-bezier(0.6,0.04,0.98,0.335);}font-family:Raleway;font-style:normal;font-weight:normal;font-size:16px;line-height:inherit;", " text-transform:", ";"], _theme["default"].lightGrey, function (props) {
  return props.fixedLabel && (0, _styledComponents.css)(["min-width:160px;"]);
}, function (props) {
  return props.uppercase ? 'uppercase' : 'none';
});
var IconSpan = _styledComponents["default"].span.withConfig({
  displayName: "IconSpan",
  componentId: "sc-vv7mya-4"
})(["margin-left:5px;float:right;"]);
var FixedLabelInput = /*#__PURE__*/function (_React$Component) {
  _inherits(FixedLabelInput, _React$Component);
  var _super = _createSuper(FixedLabelInput);
  function FixedLabelInput(props) {
    var _this;
    _classCallCheck(this, FixedLabelInput);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleUpdate", function (e) {
      // eslint-disable-line
      if ((0, _lodash.isFunction)(_this.props.onChange)) {
        _this.props.onChange(e.target.value);
      }
      _this.setState({
        value: e.target.value
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      // eslint-disable-line
      if ((0, _lodash.isFunction)(_this.props.onKeyDown)) {
        _this.props.onKeyDown(e);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getIconContainer", function () {
      if (_this.props.hasIcon && !_this.state.active) {
        return /*#__PURE__*/_react["default"].createElement(IconSpan, {
          onClick: _this.handleOnClickIcon
        }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
          iconName: _this.props.iconName,
          color: "#979797"
        }));
      }
      return null;
    });
    _this.state = {
      active: props.value && props.value.length > 0,
      hasFocus: false
    };
    _this.handleOnFocus = _this.handleOnFocus.bind(_assertThisInitialized(_this));
    _this.handleOnBlur = _this.handleOnBlur.bind(_assertThisInitialized(_this));
    _this.handleOnClickIcon = _this.handleOnClickIcon.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(FixedLabelInput, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$state = this.state,
        active = _this$state.active,
        hasFocus = _this$state.hasFocus;
      var value = this.props.value;
      var isInputActive = value && value.length > 0 || hasFocus;
      if (active !== isInputActive) {
        this.setState({
          active: isInputActive
        });
      }
    }
  }, {
    key: "handleOnFocus",
    value: function handleOnFocus(event) {
      this.setState({
        active: true,
        hasFocus: true
      });
      if (this.props.onFocus) {
        this.props.onFocus(event);
      }
    }
  }, {
    key: "handleOnBlur",
    value: function handleOnBlur(event) {
      this.setState({
        active: event.target.value.length !== 0,
        hasFocus: false
      });
      if (this.props.onBlur) {
        this.props.onBlur(event);
      }
    }
  }, {
    key: "handleOnClickIcon",
    value: function handleOnClickIcon(event) {
      this.setState({
        isClicked: false
      });
      if (this.props.hasIcon && this.props.onClickIcon) {
        this.props.onClickIcon(event);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        testID = _this$props.testID,
        label = _this$props.label,
        onBlur = _this$props.onBlur,
        onFocus = _this$props.onFocus,
        type = _this$props.type,
        refs = _this$props.refs,
        fixedLabel = _this$props.fixedLabel,
        onChange = _this$props.onChange,
        uppercase = _this$props.uppercase,
        otherProps = _objectWithoutProperties(_this$props, _excluded);
      var _this$state2 = this.state,
        active = _this$state2.active,
        hasFocus = _this$state2.hasFocus;
      var iconContainer = this.getIconContainer();
      return /*#__PURE__*/_react["default"].createElement(FloatingLabelInput, null, /*#__PURE__*/_react["default"].createElement(FloatingLabelInputContainer, {
        active: active,
        hasFocus: hasFocus,
        fixedLabel: fixedLabel
      }, /*#__PURE__*/_react["default"].createElement(FloatingLabel, {
        uppercase: uppercase,
        active: active,
        hasFocus: hasFocus,
        fixedLabel: fixedLabel
      }, label), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(FloatingInput, _extends({
        "data-cy": testID || 'FixedLabelInput',
        style: this.props.style,
        active: active,
        fixedLabel: fixedLabel,
        uppercase: uppercase,
        onBlur: this.handleOnBlur,
        onFocus: this.handleOnFocus,
        onChange: this.handleUpdate,
        onKeyDown: this.handleKeyDown,
        ref: refs,
        type: type
      }, otherProps)), iconContainer)));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    value: // @ts-ignore
    function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return FixedLabelInput;
}(_react["default"].Component);
exports["default"] = FixedLabelInput;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(FloatingLabelInput, "FloatingLabelInput", "/Users/crs/WebstormProjects/michelangelo/src/Components/FixedLabelInput.js");
  reactHotLoader.register(FloatingLabelInputContainer, "FloatingLabelInputContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/FixedLabelInput.js");
  reactHotLoader.register(FloatingLabel, "FloatingLabel", "/Users/crs/WebstormProjects/michelangelo/src/Components/FixedLabelInput.js");
  reactHotLoader.register(FloatingInput, "FloatingInput", "/Users/crs/WebstormProjects/michelangelo/src/Components/FixedLabelInput.js");
  reactHotLoader.register(IconSpan, "IconSpan", "/Users/crs/WebstormProjects/michelangelo/src/Components/FixedLabelInput.js");
  reactHotLoader.register(FixedLabelInput, "FixedLabelInput", "/Users/crs/WebstormProjects/michelangelo/src/Components/FixedLabelInput.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();